import { Trans } from '~/common/context';
import { Modal } from '@wyz/ui';
import { CUSTOMER_LEVEL } from '@wyz/types';
import { IUserCustomer } from '~/common/types';

type CustomerRelationshipContactModalProps = {
  onClose: () => void;
  selectedCustomer: IUserCustomer;
};

function CustomerRelationshipContactModal(
  props: CustomerRelationshipContactModalProps,
) {
  const { onClose, selectedCustomer } = props;

  return (
    <Modal.Container open={true} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey='app.purchase.search_page.contact_customer_relationship.modal.title' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedCustomer.level === CUSTOMER_LEVEL.N1 &&
        selectedCustomer.deliveryInformation.customerRelationshipContact
          ?.email &&
        selectedCustomer.deliveryInformation.customerRelationshipContact
          .phone ? (
          <Trans
            i18nKey='app.purchase.search_page.contact_customer_relationship.modal.description'
            values={{
              email:
                selectedCustomer.deliveryInformation.customerRelationshipContact
                  .email,
              phone:
                selectedCustomer.deliveryInformation.customerRelationshipContact
                  .phone,
            }}
            components={[
              <a
                key={0}
                href={`mailto:${selectedCustomer.deliveryInformation.customerRelationshipContact.email}`}
                className='ms-1'
                role='button'
              />,
            ]}
          />
        ) : (
          <span>
            <Trans i18nKey='app.purchase.search_page.contact_customer_relationship.modal.contact_plate_message' />
          </span>
        )}
      </Modal.Body>
    </Modal.Container>
  );
}

export default CustomerRelationshipContactModal;
